import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

export interface PaymentConfig {
  clientToken: string;
  priceId: string;
  isSandbox: boolean;
}

@Injectable({ providedIn: 'root' })
export class PaymentService {
  constructor(private auth: AuthService) {}

  async fetchConfig(): Promise<PaymentConfig> {
    const res = await fetch('/api/payment-config');
    const ct = res.headers.get('content-type') ?? '';
    if (!res.ok || !ct.includes('application/json')) {
      throw new Error(`Payment config error (${res.status})`);
    }
    const json = await res.json();
    return {
      clientToken: json.clientToken as string,
      priceId: json.priceId as string,
      isSandbox: !!json.sandboxMode,
    };
  }

  hasPaid(): Promise<boolean> {
    return this.auth.hasPaid();
  }
}
